import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// import { isMobile, isTablet, isSmartTV } from 'react-device-detect'

import CustomText from 'components/text/CustomText'
// import CustomButton from 'components/button/CustomButton'
import CustomIcon from 'components/icon/CustomIcon'
import { icons } from 'utils/icons'
import colors from 'utils/colors'
// import { BUTTONS } from 'locales/locales'
import { useImageUrl } from 'utils/hooks/useLogoUrl'
import { useAppSelector } from 'app/hooks'

const SuccessPassword = () => {
  // const { t } = useTranslation()
  const navigate = useNavigate()
  const systemSettings = useAppSelector((state) => state.system.data)
  const { imageUrl: logoUrl } = useImageUrl(systemSettings?.imageUrlLogo)

  // const handleBackToLogin = () => {
  //   navigate('/mobile-redirect')
  // }

  return (
    <Container>
      <ContentWrapper>
        <LogoWrapper>
          <Logo src={logoUrl} alt="logo" />
        </LogoWrapper>
        
        <SuccessIconWrapper>
          <CustomIcon
            source={icons.successIcon}
            iconPreset="xLarge"
            height="80px"
            width="80px"
          />
        </SuccessIconWrapper>

        <TitleWrapper>
          <CustomText typography="header1" color={colors.gray100}>
            Şifreniz Başarıyla Değiştirildi
          </CustomText>
        </TitleWrapper>

        <MessageWrapper>
          <CustomText typography="body1" color={colors.gray80} textAlign="center">
            Yeni şifrenizle mobil uygulama üzerinden giriş yapabilirsiniz.
          </CustomText>
        </MessageWrapper>

        {/* <ButtonWrapper>
          <CustomButton
            typography="header2"
            size="large"
            onClick={handleBackToLogin}
            text={t(BUTTONS.BACK_TO_SIGN_IN) as string}
            textColor={colors.white}
          />
        </ButtonWrapper> */}

        <AdditionalInfoWrapper>
          <CustomText typography="body3" color={colors.gray60} textAlign="center">
            Güvenliğiniz için lütfen şifrenizi kimseyle paylaşmayın.
          </CustomText>
        </AdditionalInfoWrapper>
      </ContentWrapper>
    </Container>
  )
}

export default SuccessPassword

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, ${colors.vime}15 0%, ${colors.white} 100%);
  padding: 20px;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  width: 100%;
  background: ${colors.white};
  border-radius: 16px;
  padding: 40px 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid ${colors.gray20};
`

const LogoWrapper = styled.div`
  max-height: 120px;
  max-width: 200px;
  margin-bottom: 30px;
`

const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const SuccessIconWrapper = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  background: ${colors.green}15;
  border-radius: 50%;
`

const TitleWrapper = styled.div`
  margin-bottom: 16px;
  text-align: center;
`

const MessageWrapper = styled.div`
  margin-bottom: 32px;
  max-width: 320px;
`

// const ButtonWrapper = styled.div`
//   width: 100%;
//   margin-bottom: 24px;
  
//   button {
//     background-color: ${colors.vime} !important;
//     border: none;
//     
//     &:hover {
//       background-color: ${colors.vimeMid} !important;
//     }
//   }
// `

const AdditionalInfoWrapper = styled.div`
  max-width: 300px;
`
